





































import {Component} from "vue-property-decorator";
import {UserLevel} from "shared/entities/user";
import * as icons from "@fortawesome/free-solid-svg-icons";
import AuthMixin from "@/mixins/auth.mixin";

@Component({})
export default class ManagementSection extends AuthMixin {
    UserLevel = UserLevel;
    icons = icons;

    comingSoon($event: MouseEvent) {
        $event.stopPropagation();
        alert("Coming Soon.");
    }
}

